<h2 mat-dialog-title class="headline">
  <mat-icon>settings</mat-icon>
  <div class="header-text">{{'ProposalSettings' | translate }}</div>
</h2>
<mat-dialog-content>
  <form [formGroup]="inputForm">
    <mat-form-field class="name-change">
      <mat-label>{{'ProposalName' | translate }}</mat-label>
      <input matInput type="text" formControlName="serviceNickname" value="{{ inputForm.value['serviceNickname'] }}" />
      @if (inputForm.value["serviceNickname"]) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="clearNickName()">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
  </form>
  <div class="grid">
    <button mat-button mat-stroked-button color="primary" class="cancel" mat-dialog-close="">
      {{'Cancel' | translate }}
    </button>
    <button mat-button mat-flat-button color="primary" (click)="save()" cdkFocusInitial>{{'Save' | translate }}</button>
  </div>
</mat-dialog-content>